// extracted by mini-css-extract-plugin
export default {"base":"SearchTable_base__wqwQm","header":"SearchTable_header__+TmYo","loading":"SearchTable_loading__KqyE7","error":"SearchTable_error__wZMd1"};